export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10797.e4e6e8b1.jpg";